// Default cart expiration in seconds
export const DEFAULT_CART_EXPIRATION_IN_SECONDS = 60 * 60 * 24 * 80; // 80 days
// Time without writes before Crystallize marks a cart stale and then abandoned.
// Abandoned carts lose their promotions (e.g. free shipping). Crystallize default is 1 hour.
export const DEFAULT_CART_STALE_TTL_IN_SECONDS = 60 * 60 * 4; // 4 hours
export const CartType = {
    SHOP: "shop",
    EVALUATION_COPY: "evaluation-copy",
    ORGANIZATION: "organization",
};
export const CART_META_KEY = {
    CART_TYPE: "cartType",
    CART_API_VERSION: "cartApiVersion",
    CART_FREE_SHIPPING_THRESHOLD: "freeShippingThreshold",
    ORDER_SOURCE: "orderSource",
    /** Reference of the latest Vipps Hurtigkasse payment started for the cart. */
    VIPPS_REFERENCE: "vippsReference",
};
export const CART_ITEM_META_KEY = {
    /** Preorder release date (yyyy-MM-dd), set when the item is added. */
    RELEASE_DATE: "releaseDate",
};
